export default __webpack_public_path__ + "static/media/edit.f82392d2.png";